export enum TranslationUrl {
  TRANSLATIONS = '/translations',
}
